/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-12-10 14:31:32
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-27 15:09:57
 * @change:JokerShaw
 */
import React, {Component} from 'react'
import './index.css'
import Template from '../template'
import {Form, Input, Button, Table, Modal, Row, Col, Statistic, InputNumber, Space} from 'antd';
import axios from 'axios'
import {message} from 'antd';
import {connect} from 'react-redux';
import moment from 'moment'
import coinIcon from '../img/icon-cion.png'
import {PlusOutlined} from "@ant-design/icons";


class MyCoin extends Component {

    state = {
        //积分总数
        coinCount: 0,
        //表格数据总数
        total: 0,
        //数据列表
        coinOprationList: [],
        apllyModal: false,
        applyScore: 200,
    }

    componentDidMount() {

        setTimeout(() => this.getCoinCount(), 1000)
        setTimeout(() => this.getCoinOprationList(1), 1000)
        // this.getCoinCount()
        // this.getCoinOprationList(1,1)
    }

    getCoinCount = async () => {
        let userId

        try {

            userId = (this.props.user).toJS().userId
            console.log((this.props.user).toJS())

        } catch (error) {
            console.log(error)
        }

        const {data: res} = await axios.get(`${window.url.score}/score/getbyid?userId=${userId}`, {
            withCredentials: false,
            headers: {
                'Authorization': (this.props.user).toJS().token
            }
        })

        // console.log(res)

        if (res.code !== '200' || res.payload === null) {
            message.error('积分获取失败！')
        } else {
            this.setState({
                coinCount: res.payload.score
            })
        }

    }

    getCoinOprationList = async (page) => {
        let userId

        try {

            userId = (this.props.user).toJS().userId
            // console.log(userId)

        } catch (error) {
            console.log(error)
        }

        const {data: res} = await axios.get(`${window.url.score}/operation/page?userId=${userId}&limit=6&page=${page}`)


        if (res.code !== '200' || res.payload === null) {
            message.error('积分记录获取失败！')
        } else {
            res.payload.records.map((e) => {
                e.key = e.operationId
            })
            this.setState({
                total: res.payload.total,
                coinOprationList: res.payload.records
            })
        }

        // console.log(res)
        // console.log(this.state.coinOprationList)
    }

    changePage = (current) => {
        this.getCoinOprationList(current);
    }

    changeApplyScore = (value) => {
        this.setState({applyScore: value})
    }
    putApplyScore = () => {
        const {coinCount, applyScore} = this.state
        const {userId, userName} = (this.props.user).toJS()
        let sendDate = {
            applyScore: applyScore,
            oldScore: coinCount,
            userId: userId,
            userName: userName
        }
        axios.post(global.url.score + '/score/putReviewScoreApply', sendDate).then(
            res => {
                if (res.data.code === "200") message.success(res.data.message);
                else console.log(res.data.message())
            }
        ).catch((e) => {
            console.log(e);
        })
        this.setState({apllyModal: false})
    }

    render() {
        const columns = [
            {
                title: '操作类型',
                dataIndex: 'operationType',
                key: 'operationType',
            },
            {
                title: '时间',
                dataIndex: 'operationTime',
                key: 'operationTime',
                render: (orderCreationTime, data) => {
                    return <span>{moment(orderCreationTime).format("YYYY-MM-DD HH:mm:ss")}</span>
                }
            },
            {
                title: '积分变化',
                dataIndex: 'scoreChange',
                key: 'scoreChange',
            },
        ];
        return (
            <Template title="我的积分">
                {/* <div className={"usercenter-mycoin-coin-backpanel"}>
          <div className={"usercenter-mycoin-coin-panel"}>
            <div className={"usercenter-mycoin-coin-panel-text"}>
              当前积分：
            </div>
            <div className={"usercenter-mycoin-coin-panel-cointext"}>
              {this.state.coinCount}
            </div>
            <div
              className={"usercenter-mycoin-coin-circle"}
              style={{ width: 135, height: 135, left: -32, top: 84 }}
            ></div>
            <div
              className={"usercenter-mycoin-coin-circle"}
              style={{ width: 63, height: 63, left: 146, top: 140 }}
            ></div>
            <div
              className={"usercenter-mycoin-coin-circle"}
              style={{ width: 39, height: 39, left: 363, top: 19 }}
            ></div>
            <div
              className={"usercenter-mycoin-coin-circle"}
              style={{ width: 119, height: 119, left: 411, top: 71 }}
            ></div>
          </div>
        </div>
        <div
          style={{
            height: 12,
            backgroundColor: "rgba(228, 233, 241, 1)",
            width: "100%",
          }}
        ></div>
        <div className={"usercenter-mycoin-coinchange-backpanel-mycoin"}>
          <div className={"usercenter-mycoin-coinchange-title-panel"}>
            <div className={"usercenter-mycoin-coinchange-titletext"}>
              积分记录
            </div>
          </div>
          <div className={`usercenter-mycoin-table`}>
            <Table
              pagination={{
                showSizeChanger: false,
                showQuickJumper: false,
                showTotal: () => `共${this.state.total}条`,
                pageSize: 6,
                //   current: this.state.page,
                total: this.state.total,
                onChange: (current) => this.changePage(current),
              }}
              scroll
              className="usercenter-mycoin-coinchange-table"
              dataSource={this.state.coinOprationList}
              columns={columns}
            />
          </div>
        </div> */}
                <div className="usercenter-mycoin-coin-card-wrap">
                    <img src={coinIcon} className="usercenter-mycoin-coin-img"></img>
                    <div className="usercenter-mycoin-coin-number-area">
                        <div className="usercenter-mycoin-coin-text">我的积分</div>
                        <div className="usercenter-mycoin-coin-count">{this.state.coinCount}</div>
                    </div>
                    <div className="usercenter-mycoin-coin-card-first-line">
                        <Button className="usercenter-mycoin-coin-card-button" size="middle" onClick={() => {
                            this.setState({apllyModal: true})
                        }}>申请积分</Button>
                    </div>
                </div>
                <Modal title="积分申请" visible={this.state.apllyModal}
                       onCancel={() => this.setState({apllyModal: false})}
                       onOk={this.putApplyScore}
                >
                    <Space size={60}>
                        <Statistic title="原有积分" value={this.state.coinCount}/>
                        <PlusOutlined style={{fontSize: "17px",}}/>
                        <div className="apply-score-text-box">
                            <div className="apply-score-text">申请积分</div>
                            <InputNumber min={1} max={10000} step={10} defaultValue={200} style={{fontSize: "21px"}}
                                         onChange={this.changeApplyScore}/>
                        </div>
                        <Statistic title="申请后积分" value={this.state.applyScore + this.state.coinCount}/>
                    </Space>
                </Modal>
                <div className="usercenter-mycoin-coin-operate-wrap">
                    <div className="usercenter-mycoin-coin-operate-title">积分记录</div>
                    <div className="usercenter-mycoin-coin-operate-table">
                        <Table
                            pagination={{
                                showSizeChanger: false,
                                showQuickJumper: false,
                                showTotal: () => `共${this.state.total}条`,
                                pageSize: 6,
                                //   current: this.state.page,
                                total: this.state.total,
                                onChange: (current) => this.changePage(current),
                            }}
                            scroll
                            className="usercenter-mycoin-coinchange-table"
                            dataSource={this.state.coinOprationList}
                            columns={columns}
                        />
                    </div>
                </div>
            </Template>
        );

    }
}

const mapState = (state) => ({
    user: state.userReducer.get('user'),
})

export default connect(mapState)(MyCoin) 